import { createGlobalStyle } from 'styled-components';

export const AppStyle = createGlobalStyle`
  .RUIRoot {
    margin: -8px;

    .RUIText-base {
      margin-bottom: 0;
    }

    .RUIDropdown-base {
      z-index: 3;
      max-height: 200px;
      overflow-y: auto;
    }
  }
`;
